
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatSnackBar } from '@angular/material';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ClipBoardService } from '../../services/clipboard.service';
import { ServerService } from 'src/app/services/server.service';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
@Component({
    selector: 'whatsapp-profile-modal',
    templateUrl: './whatsapp-profile-modal.component.html',
    styleUrls: ['./whatsapp-profile-modal.component.scss']
})
export class WhatsappProfileModalComponent implements OnInit {
    authToken = localStorage.getItem("token");
    selectedTemplate:any;
    btnStatus: boolean = false
    profile: any;
    projectID: string;
    userForm: FormGroup;
    body_content:any;
    safeVideoUrl: any;
    allButtonValue:any;
    initialValue:any=[];
    templatechanged;
    image_preview_link:any;
    modifiedOBJ:any = {}
    modifiedARR:any = []
    showWhatsappForm:any= false;
    button_one_obj:any={}
    button_two_obj:any={}
    button_three_obj:any={};
    imageData: any;
    templates:any;

    constructor(
        public clipBoardService: ClipBoardService,
        public serverService: ServerService,
        private fb: FormBuilder,
        private http:HttpClient,
        private snackBar: MatSnackBar,
        private sanitizer: DomSanitizer,
        private dialogRef: MatDialogRef<WhatsappProfileModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data) {
        this.profile = this.data.whats_app_profile
        this.projectID = this.data.id   
    }

    ngOnInit() {
        this.templatechanged = false
        this.allWhatsappsTemplates();
        if(this.data.whats_app_profile){
            this.initialValue = null
            this.selectedTemplate =this.data.whats_app_profile["approved_template"]["name"]
            this.image_preview_link = this.data.whats_app_profile["message_data"].components_json[0].parameters[0]["image"]["link"];
            this.fetchImage()
            this.body_content = this.data.whats_app_profile["approved_template"].components[1]["text"];
            let variable_value = this.data.whats_app_profile["message_data"].components_json[1].parameters;
            if(variable_value != null){
            this.initialValue = variable_value.map((data,index)=>{
                return {...data,text:data.text,key:"{{"+(index+1)+"}}",copy_key:data.text}
            })
        }
            this.allButtonValue = this.data.whats_app_profile["button_action_data"];
            // console.log(this.allButtonValue)
            // this.allButtonValue = this.allButtonValue.reverse();
            for (const property in this.allButtonValue) {
            
            this.modifiedOBJ = {}
            this.modifiedOBJ['opt_out']=this.allButtonValue[property].opt_out;
            this.modifiedOBJ['reply_text']=this.allButtonValue[property].reply_text;
            this.modifiedOBJ['lead_remark']=this.allButtonValue[property].lead_remark;
            this.modifiedOBJ['lead_status']=this.allButtonValue[property].lead_status;
            this.modifiedOBJ['text']=property;
            
            this.modifiedARR.push(this.modifiedOBJ)
            
             }
            //  console.log(this.modifiedARR.reverse());
            this.allButtonValue = this.modifiedARR;
            // console.log(this.allButtonValue)
        }
        
    }
    close() {
        this.dialogRef.close();
    }
    allWhatsappsTemplates(){
        this.serverService.getAllWhatsappTemplates(this.authToken).subscribe((data)=>{
            this.templates = data.templates.data;
        })
    }
    showForm(element:any){
        // element.value['components'][1].example = null;
        // debugger;
        this.templatechanged = true
        this.selectedTemplate = element.value;
        // console.log(this.selectedTemplate)
        this.body_content = element.value['components'][1].text;
        if(this.selectedTemplate['components'][1].example != null ){
            this.initialValue = element.value['components'][1].example.body_text[0].map((data,index)=>{
                return {key:"{{"+(index+1)+"}}",value:data,copy_key:data} 
              })
        }
        else{
            this.initialValue = null;
        }
        
        
       
        this.allButtonValue = element.value['components'][3].buttons.map((data)=>{
                return {lead_status:"",lead_remark:"",opt_out:false,reply_text:"",...data}
        })
        // this.allButtonValue.reverse();
        // console.log(this.allButtonValue)
        this.image_preview_link = element.value['components'][0]["example"].header_handle[0];
        this.fetchImage();
        this.showWhatsappForm = true;
    }
    changeVariablesValue(event,i:any){

        if(event.target.value != ''){
            this.body_content = this.body_content.replace(this.initialValue[i].key,event.target.value)
            this.initialValue[i].key = event.target.value
            this.initialValue[i].copy_key = event.target.value;
        }
       
    }
        fetchImage(): void {
                this.http.get( this.image_preview_link, { responseType: 'blob' }).subscribe(
                    (blob) => {
                      const objectURL = URL.createObjectURL(blob);
                      this.imageData = this.sanitizer.bypassSecurityTrustUrl(objectURL);
                    },
                    (error) => {
                      console.error('Error fetching image:', error);
                    }
                  );
          }
    save(){
        let changedVariablesValue;
        if( this.initialValue != null){
         changedVariablesValue = this.initialValue.map((data)=>{
            return {type:"text",text:data.key}
        })
    }
    else {
        changedVariablesValue = null
    }
        // console.log(this.allButtonValue)
    //    this.allButtonValue  = 
       let output = this.convertArrayToObject(this.allButtonValue);
    //    console.log(output)
    // console.log(this.allButtonValue)
        let body = {
            'project_id':this.data.id,
            'approved_template':this.selectedTemplate,
            'message_data': {"components_json":[{
                            'type':'header',
                            'parameters':[{
                                    'type':'image',
                                    'image':{
                                        'link':this.image_preview_link
                                            }
                                        }]
                                    },
                        
                                {
                                    'type':'body',
                                    'parameters':changedVariablesValue
                                }
                            ]},
                        'button_action_data':output
                        
                        }

        this.serverService.createWhatsappProfileByTemplate(body,this.authToken).subscribe((data)=>{
            // console.log(data)
            this.clipBoardService.showMessgeInText("Whatsapp Profile Created Succesfully", "success-snackbar")
            this.dialogRef.close(data)
        })
        // console.log(body)
   
    }
    edit(){
        // console.log(this.data.whats_app_profile)
        // console.log(this.initialValue)
        let changedVariablesValue = this.initialValue.map((data)=>{
            return {type:"text",text:data.copy_key}
        })
        let output  = this.convertArrayToObject(this.allButtonValue);
    //    console.log(output)
        // console.log()
        let body = {
            'project_id':this.data.id,
            'approved_template':this.selectedTemplate,
            'message_data': {"components_json":[{
                            'type':'header',
                            'parameters':[{
                                    'type':'image',
                                    'image':{
                                        'link':this.image_preview_link
                                            }
                                        }]
                                    },
                        
                                {
                                    'type':'body',
                                    'parameters':changedVariablesValue
                                }
                            ]},
                        'button_action_data':output
                        
                        }
                        // console.log(body)
                        
        this.serverService.updateWhatsappProfileByProjectId(this.data.whats_app_profile.id,body,this.authToken).subscribe((data)=>{
            // console.log(data)
            this.clipBoardService.showMessgeInText("Whatsapp Profile Updated Succesfully", "success-snackbar")
            this.dialogRef.close(data)
        })
        // console.log(this.data.whats_app_profile)
    }
    buttonValueChanged(event,i,valueSelected){
        

        if(valueSelected == 'status'){
            this.allButtonValue[i]["lead_status"] = event.value 
         
        }
       if(valueSelected == 'remark'){

        this.allButtonValue[i]["lead_remark"] = event.target.value
    }
    if(valueSelected == 'reply_text'){
        this.allButtonValue[i]["reply_text"] = event.target.value
    }
    if(valueSelected == 'opt_out' && event.target.checked){
       this.allButtonValue[i]["opt_out"] = true
    }
   

    }
    convertArrayToObject(array) {
        const result = {};
        array.forEach((obj) => {
            if (typeof obj !== 'object' || !obj.hasOwnProperty('text')) {
              throw new Error("All elements in the array must be objects with a 'text' property.");
            }
        
            const { text, ...rest } = obj;
            result[text] = rest;
          });

  return result;
}
getButtonWidth(isOdd: any,arr:any) {
    // console.log(arr.length)
    let len = arr.length-1;
    return isOdd && isOdd == len ? '100%' : '49%';
  }
}